document.addEventListener('alpine:init', () => {
    window.Alpine.magic('scrollToTop', () => event => {
        window.scrollTo({top: 0, behavior: "smooth"});
    });
});
document.addEventListener('alpine:init', () => {
    window.Alpine.data('scrollToTopComponent', () => ({
        showButton: false,
        init() {
            let firstHeadline = document.querySelector('h1');
            let footerHeight = document.querySelector('footer').clientHeight;
            let documentHeight = document.querySelector('body').clientHeight;
            window.addEventListener('scroll', () => {
                this.showButton = window.helpers.scrolledOverH1Headline(firstHeadline, footerHeight, documentHeight);
            });
        }
    }));
});
